import packageInfo from '../../package.json';

export const environment = {
	development: false,
	production: true,
	dataUrl: "https://test-customiser-api.lindberg.com",
	imageUrl: "https://customiser-images.lindberg.com",
	imageCDNUrl: "https://customiser-images.lindberg.com",
	hmr: false,
	appInsightsKey: "dfa1581e-e811-431c-a80c-9eb06b8b3a8e",
	realtimeUrl: 'https://test-realtime.lindberg.com',
	realTimeComponentUrl: 'https://test-realtime.lindberg.com/V2/ModelViewer.js',
	fileMakerAppsUrl: 'https://fmtest.lindberg.com/fmi/webd'
};

